<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Drainage';
                }
            },
            component_id: {
                default(){
                    return 'drainage';
                }
            },
            cill: {
                required: true
            },
            threshold: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.cill, this.threshold);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-drainage?cill=' + this.cill + '&threshold=' + this.threshold;
            },
            cache_key(){
                return '_' + this.cill + '_' + this.threshold;
            }
        },
        watch: {
            'cill': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
            'threshold': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
        }
    }
</script>
